import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MobileStepper from '@mui/material/MobileStepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import { useMediaQuery } from '@mui/material';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { useTheme } from '@mui/material/styles';
import { useFlow } from '../context/FlowContext';
import { useI18N } from '../context/I18NContext';
import { useSettings } from '../context/SettingsContext';
import useWidgetStore from '../store/useWidgetStore';
const HorizontalNav = ({ children }) => {
    var _a, _b, _c, _d, _e, _f;
    const theme = useTheme();
    const { t } = useI18N();
    const [activeStep, setActiveStep] = useState(0);
    const [steps, setSteps] = useState([]);
    const [maxSteps, setMaxSteps] = useState(0);
    const [hasBack, setHasBack] = useState(true);
    const [showSummary, setShowSummary] = useState(false);
    const { hasBooking } = useWidgetStore();
    const { debug, hasAccounts, widgetMode } = useSettings();
    const flow = useFlow();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm')) && widgetMode !== "standalone";
    useEffect(() => {
        let _steps = [];
        flow.views.forEach((view) => {
            _steps.push(view.route);
        });
        setSteps(_steps);
        setMaxSteps(flow.steps);
        setActiveStep(flow.currentStep);
    }, [flow.currentView]);
    useEffect(() => {
        // if (flow) {
        //     flow?.checkFlow()
        // }
    }, []);
    useEffect(() => {
        var _a, _b, _c, _d;
        if (flow === null || flow === void 0 ? void 0 : flow.insideFlow) {
            let view = flow.views[flow.currentStep];
            setHasBack(!(((_a = view === null || view === void 0 ? void 0 : view.config) === null || _a === void 0 ? void 0 : _a.hasPrevious) !== undefined && !((_b = view === null || view === void 0 ? void 0 : view.config) === null || _b === void 0 ? void 0 : _b.hasPrevious)));
        }
        setShowSummary(hasBooking === true && !['select', 'select1', 'select2', 'summary', 'thankYou'].includes((_d = (_c = flow === null || flow === void 0 ? void 0 : flow.currentRoute) === null || _c === void 0 ? void 0 : _c.route) !== null && _d !== void 0 ? _d : ''));
    }, [flow === null || flow === void 0 ? void 0 : flow.currentRoute]);
    let bottom = 0;
    if (hasAccounts)
        bottom += 64;
    return (_jsx(_Fragment, { children: _jsxs(Box, { sx: { position: 'relative', flexGrow: 1, paddingTop: showSummary ? '60px' : '20px' }, children: [isDesktop && (_jsxs(_Fragment, { children: [_jsx(Box, { sx: { zIndex: 1, position: 'fixed', top: showSummary ? '120px' : (debug ? '48px' : 0), paddingY: '20px', width: '100%', background: theme.palette.background.paper }, children: _jsx(Stepper, { activeStep: activeStep, sx: { position: 'sticky', top: 0 }, children: steps.map((step, index) => {
                                    const stepProps = {};
                                    const labelProps = {};
                                    return (_jsx(Step, Object.assign({}, stepProps, { children: _jsx(StepLabel, Object.assign({}, labelProps, { children: t(step.label, 'nav') })) }), step.label));
                                }) }) }), _jsxs(Box, { sx: { paddingTop: showSummary ? '52px' : '30px' }, children: [_jsx(Box, { sx: { padding: 1, minHeight: '100vh', maxWidth: 'calc(100vw - 16px)' }, children: children }), _jsxs(Box, { sx: {
                                        position: 'fixed',
                                        width: '100%',
                                        bottom: 0,
                                        background: theme.palette.background.paper,
                                        borderTopWidth: 1,
                                        borderStyle: "solid",
                                        borderColor: theme.palette.divider,
                                        display: 'flex',
                                        flexDirection: 'row',
                                        pt: 2
                                    }, children: [hasBack && activeStep > 0 && (_jsx(Button, { color: "inherit", disabled: activeStep === 0, onClick: flow.onPrevious, sx: { mr: 1 }, children: t('Vorige', 'nav') })), ((_a = flow.currentRoute) === null || _a === void 0 ? void 0 : _a.actionLabel) && (_jsx(Box, { sx: { flex: '1 auto', textAlign: 'right' }, children: _jsx(Button, { onClick: flow.onNext, sx: { mr: 1 }, variant: "contained", children: (_c = (_b = flow.currentRoute) === null || _b === void 0 ? void 0 : _b.actionLabel) !== null && _c !== void 0 ? _c : t('Volgende', 'nav') }) }))] })] })] })), !isDesktop && (_jsxs(_Fragment, { children: [_jsxs(Box, { sx: { width: '100%', marginBottom: '2em' }, children: [_jsx(Box, { sx: { padding: 1, minHeight: '100vh', maxWidth: 'calc(100vw - 16px)' }, children: children }), ((_d = flow.currentRoute) === null || _d === void 0 ? void 0 : _d.actionLabel) && (_jsx(Button, { fullWidth: true, onClick: flow.onNext, sx: { mr: 1 }, variant: "contained", children: (_f = (_e = flow.nextRoute) === null || _e === void 0 ? void 0 : _e.label) !== null && _f !== void 0 ? _f : t('Volgende', 'nav') }))] }), _jsx(MobileStepper, { variant: "text", steps: maxSteps, activeStep: activeStep, sx: {
                                background: theme.palette.background.paper,
                                borderTopWidth: 1,
                                borderStyle: "solid",
                                borderColor: theme.palette.divider,
                                flexGrow: 1,
                                position: 'fixed',
                                bottom: bottom + 'px',
                                left: 0,
                                width: 'calc(100% - 16px)'
                            }, nextButton: _jsx(_Fragment, {}), backButton: _jsx(_Fragment, { children: hasBack && activeStep > 0 && (_jsxs(Button, { size: "large", onClick: flow.onPrevious, disabled: activeStep === 0, children: [theme.direction === 'rtl' ? (_jsx(KeyboardArrowRight, {})) : (_jsx(KeyboardArrowLeft, {})), t('Vorige', 'nav')] })) }) })] }))] }) }));
};
export default HorizontalNav;
